import { Pressable } from '@/components/ui/pressable';
import { View } from '@/components/ui/view';
import { HStack } from '@/components/ui/hstack';
import { createStackNavigator } from '@react-navigation/stack';
import MainStack from '../../containers/MainStack';
import { IconM } from '../../components/media/IconsV2';
import { switchScreen } from '../../hooks/navigate';

const appStack = createStackNavigator();

export default function AppView({ navigation }) {
    const onClose = () => {
        switchScreen(navigation, 'BACK');
    };

    return (
        <View className="flex-1 w-[390px] max-h-[844px] m-auto bg-secondary-50 justify-center border border-primary-900 shadow-hard-3">
            <HStack className="absolute -top-[48px] right-0">
                <View className="bg-primary-50 border border-primary-900 rounded-[4px] p-1 mr-[2px]">
                    <IconM className="text-primary-900" size={30} name="close" />
                    <Pressable onPress={onClose} className="absolute w-8 h-8" />
                </View>
            </HStack>
            <appStack.Navigator initialRouteName="MainStack">
                <appStack.Screen name="MainStack" component={MainStack} options={{ headerShown: false }} />
            </appStack.Navigator>
        </View>
    );
}
